export const SM_AVATAR_SIZE = 48;

export const AVATAR_ONLINE_ID_SIZE = 10;

export const COLLECT_ICON_SIZE = 24;
